var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUiSolitionGridElementHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 184.327,
    height: 172.904,
    viewBox: "0 0 184.327 172.904",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI_Solition_grid_element_highlighted",
    transform: "translate(3.004 3.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_921",
    "data-name": "Tracciato 921",
    d: "M2.484,57.457.649,114.442l3.626,45.647,30.936,1.443,126.739.812,14.176-2.9V142.707l2.845-91.864-.607-34.749L153.586-1.632,20.969-2.417,1.407-4.257Z",
    transform: "translate(-0.649 4.257)",
    fill: "#fef1d2",
    stroke: "#826c9f",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1065",
    "data-name": "Tracciato 1065",
    d: "M2.349,51.239l-1.7,51.243,3.358,41.047,28.651,1.3,69.486,2.02,54.8-3.318V128.483l2.635-82.608-.562-31.248-22.95-15.94L19.468-2.6,1.351-4.257Z",
    transform: "translate(7.596 12.651)",
    fill: "none",
    stroke: "#c78b43",
    strokeWidth: 2,
    strokeDasharray: 7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiSolitionGridElementHighlighted);
export default __webpack_public_path__ + "static/media/UI_Solition_grid_element_highlighted.5c6292ab6dddf5c68b8e519c0175abdc.svg";
export { ForwardRef as ReactComponent };